import $ from 'jquery'
$(document).on('turbolinks:load', function () {
  const $slider = $('.slider')
  $slider.bootstrapSlider()
})
